import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import moment from 'moment'
import { FormFieldComponent } from '../form-field/form-field.component'
import { DateRangePickerSelection } from '../date-range-picker/date-range-picker.component'

@Component({
  selector: 'app-form-daterange-input',
  templateUrl: './form-daterange-input.component.html',
  styleUrls: ['../form-field-common.scss', './form-daterange-input.component.scss'],
  host: { class: 'form-daterange-field' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormDaterangeInputComponent extends FormFieldComponent {
  @Input() clearable = true
  @Input() dateFormat = 'DD/MM/YYYY'

  @Input() allowSingleDay = false
  @Input() maxDate: Date
  @Input() minDate: Date
  @Input() startDate: Date

  onDateRangeChange(value: DateRangePickerSelection) {
    setTimeout(() => {
      this.ctrl.markAsTouched()
      this.ctrl.setValue(value)
    })
  }

  getInputText = (value: DateRangePickerSelection) => {
    if (!value) return ''
    return (
      this.unixToMoment(value.from).format(this.dateFormat) +
      ' - ' +
      this.unixToMoment(value.to).format(this.dateFormat)
    )
  }

  unixToMoment(unix: number) {
    return moment.utc(unix * 1000)
  }

  onOpen() {
    this.focused = true
  }

  onClose() {
    this.focused = false
  }
}
